import {useState, useEffect} from 'react';
import moment from 'moment';
import {DeprecatedButton} from 'shipwell-ui';
import {getShipmentPickups} from 'App/api/shipment';
import ShipwellLoader from 'App/common/shipwellLoader';
import './styles.scss';

const SchedulePickup = (props) => {
  const {shipment, filters = {}, onCancel, onCreatePickup, onUpdatePickup, currentPickup} = props;
  const [pickups, setPickups] = useState([]);
  const [fetchingPickups, setFetchingPickups] = useState(false);
  const [updatingPickup, setUpdatingPickup] = useState(null);

  const pickupAddress =
    shipment &&
    shipment.stops &&
    shipment.stops[0] &&
    shipment.stops[0].location.address &&
    shipment.stops[0].location.address.formatted_address;

  const defaultFilters = {
    scheduledDateGte: moment().format('YYYY-MM-DD'),
    pageSize: 1000,
    cancelled: false,
    ordering: 'scheduled_date'
  };

  const requestShipmentPickups = async () => {
    setFetchingPickups(true);
    try {
      const response = await getShipmentPickups({...defaultFilters, ...filters});

      if (response && response.body && response.body.results) {
        const pickups = response.body.results.filter((pickup) => {
          if (currentPickup) {
            // only show pickup if address matches pickup address from shipment
            // and it's not the current pickup
            return (
              pickup.id !== currentPickup.id &&
              pickup.address &&
              pickup.address.formatted_address &&
              pickupAddress &&
              pickupAddress === pickup.address.formatted_address
            );
          }
          // only show pickup if address matches pickup address from shipment
          return (
            pickup.address &&
            pickup.address.formatted_address &&
            pickupAddress &&
            pickupAddress === pickup.address.formatted_address
          );
        });

        setPickups(pickups);
      }
    } catch (error) {
      console.error(error);
    }
    setFetchingPickups(false);
  };

  const handleSelectPickup = async (selectedPickup) => {
    if (onUpdatePickup && selectedPickup) {
      setUpdatingPickup(selectedPickup);
      await onUpdatePickup(selectedPickup);
      setUpdatingPickup(null);
    }
  };

  const handleCreatePickup = () => {
    if (onCreatePickup) {
      onCreatePickup();
    }
  };

  useEffect(() => {
    requestShipmentPickups();
  }, []);

  return (
    <div className="schedule-pickup">
      <div className="schedule-pickup__header">
        <DeprecatedButton variant="tertiary" disabled={Boolean(updatingPickup)} onClick={() => handleCreatePickup()}>
          Add New Pickup
        </DeprecatedButton>
      </div>
      {fetchingPickups && <ShipwellLoader loading={fetchingPickups} loadingText="Searching for available pickups..." />}
      {!fetchingPickups && (
        <ul className="schedule-pickup__options">
          {pickups.map((pickup) => (
            <li key={pickup.id}>
              <div>
                <p>
                  <strong>{pickup.address && pickup.address.formatted_address}</strong>
                </p>
                <strong>{moment(pickup.scheduled_date).format('ddd, MMM D')}</strong>
                <p>
                  Between {moment(pickup.time_window_start, 'HH:mm:ss').format('HH:mm')} -{' '}
                  {moment(pickup.time_window_end, 'HH:mm:ss').format('HH:mm')}
                </p>
              </div>
              <DeprecatedButton
                variant="tertiary"
                disabled={Boolean(updatingPickup)}
                icon={updatingPickup && updatingPickup.id === pickup.id && <i className="icon icon-Restart rotate" />}
                onClick={(e) => handleSelectPickup(pickup)}
              >
                Use This Pickup
              </DeprecatedButton>
            </li>
          ))}
        </ul>
      )}
      {!fetchingPickups && pickups.length < 1 && <p className="empty-pickup">No future pickups scheduled.</p>}
      <div className="schedule-pickup__footer">
        <DeprecatedButton variant="secondary" onClick={onCancel}>
          Cancel
        </DeprecatedButton>
      </div>
    </div>
  );
};

export default SchedulePickup;
